import { X } from 'lucide-react';
import { useNavigateWithContentFlush } from '@/hooks/useNavigateWithContentFlush';
import { Button } from '@/components/ui/button';
import { useBillingSummary, useStartSubscription, useStartTopup } from '@/hooks/useBillingQueries';
import { useBillingUiStore } from '@/store/billingUiStore';

export function BillingNotice() {
  const navigate = useNavigateWithContentFlush();
  const paymentBlock = useBillingUiStore((state) => state.paymentBlock);
  const clearPaymentBlock = useBillingUiStore((state) => state.clearPaymentBlock);
  const lowBalanceDismissed = useBillingUiStore((state) => state.lowBalanceDismissed);
  const dismissLowBalance = useBillingUiStore((state) => state.dismissLowBalance);
  const startSubscription = useStartSubscription();
  const startTopup = useStartTopup();
  const { data } = useBillingSummary();

  if (paymentBlock) {
    const isNoSubscription = paymentBlock.reason === 'NO_SUBSCRIPTION';
    return (
      <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-md border bg-background px-4 py-3 shadow-lg">
        <span className="text-sm">
          {isNoSubscription
            ? 'A subscription is required to continue.'
            : "You're out of credit. Add credit to continue."}
        </span>
        {isNoSubscription ? (
          <Button size="sm" onClick={() => startSubscription.mutate()} disabled={startSubscription.isPending}>
            Subscribe
          </Button>
        ) : (
          <Button size="sm" onClick={() => navigate('/settings/billing')}>
            Add credit
          </Button>
        )}
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={clearPaymentBlock}>
          <X className="h-4 w-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
      </div>
    );
  }

  if (data?.summary.lowBalance && !lowBalanceDismissed) {
    return (
      <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-md border bg-background px-4 py-3 shadow-lg">
        <span className="text-sm">Your wallet balance is low.</span>
        <Button size="sm" variant="outline" onClick={() => startTopup.mutate(10)} disabled={startTopup.isPending}>
          Add credit
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={dismissLowBalance}>
          <X className="h-4 w-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
      </div>
    );
  }

  return null;
}
